import type { GenericError, RequestStatus } from '@skynet/data-ws-core';
import type { DepthNumber } from '@skynet/loans';

export type LoansSummaryTimeFrame = '24h' | '7d';

export enum LoansSummaryCommands {
  LoansSummary = 'LoansSummary',
}

export interface LoansSummaryState {
  data: LoansSummaryJson[] | null;
  status: RequestStatus;
  searchValue: string;
  sortKey: string;
  error: GenericError | null;
  timeFrame: LoansSummaryTimeFrame;
}

export interface JsonLoansSummarySuccess {
  command: LoansSummaryCommands.LoansSummary;
  loans: LoansSummaryJson[];
}

interface LoansSummaryTotalToken {
  token: string;
  value: number;
  usd: number;
}

export interface LoansSummaryJson {
  LoanID: number;
  Token: string;
  tokens: string[];
  TotalValue: number;
  TotalValue24hChange: number;
  TotalValue7dChange: number;
  MaxProfit: number;
  MaxProfit24hChange: number;
  MaxProfit7dChange: number;
  TokenPrice: number;
  TokenPrice24hChange: number;
  TokenPrice7dChange: number;
  TotalToken: LoansSummaryTotalToken;
  QuoteAmount: number;
  CommittedCapitalUSD: number;
  TradingVolume24h: number;
  TradingVolume24hChange: number;
  TradingVolume7dChange: number;
  ourActualLiquidity: Record<DepthNumber, number>;
  TotalDepthProvided: number;
  ExchangesCovered: number[];
  RemainingTermOfTheLoan: number;
  StartDate: string;
  EndDate: string;
  Name: string;
}

export type LoansSummaryItem = LoansSummaryJson & { ExchangeName: string[] };
